
import { Component, Input, OnDestroy } from '@angular/core';
import { CollaborationService } from '@features/collaboration/collaboration.service';
import { ModalFactory } from '@yourcause/common/modals';
import { Subscription } from 'rxjs';
import { CollaborationModalComponent } from '../collaboration-modal/collaboration-modal.component';

@Component({
    selector: 'gc-manage-collaborators',
    template: `
  <ng-template #innerContent>
    <yc-fa icon="user-plus"
      [light]="true"
      [class.text-link]="isDropdownItem"
      class="me-2">
    </yc-fa>
    <yc-i18n *ngIf="!hideNumberOfApplicants &&
      numberOfApplicants"
      [key]="forNomination ?
        'APPLY:textManageNominatorsDynamic' :
        'APPLY:textManageApplicantsDynamic'"
      [defaultValue]="forNomination ?
        'Manage nominators (__number__)' :
        'Manage applicants (__number__)'"
      [context]="{
        number: numberOfApplicants
      }">
    </yc-i18n>
    <yc-i18n *ngIf="hideNumberOfApplicants ||
      !numberOfApplicants"
      [key]="forNomination ?
        'APPLY:textManageNominators' :
        'common:textManageApplicants'"
      [defaultValue]="forNomination ?
        'Manage nominators' :
        'Manage applicants'">
    </yc-i18n>
  </ng-template>

  <yc-button *ngIf="!isDropdownItem"
    [link]="true"
    (onClick)="openModal()">
    <ng-container *ngTemplateOutlet="innerContent"></ng-container>
  </yc-button>

  <!-- As Dropdown -->
  <div *ngIf="isDropdownItem">
    <a href="javascript:" (click)="openModal()">
      <ng-container *ngTemplateOutlet="innerContent"></ng-container>
    </a>
  </div>
  `,
    styleUrls: ['manage-collaborators.component.scss'],
    standalone: false
})
export class ManageCollaboratorsComponent implements OnDestroy {
  @Input() sendNotificationsByDefault: boolean;
  @Input() applicationId: number;
  @Input() forNomination = false;
  @Input() hideNumberOfApplicants = false;
  @Input() numberOfApplicants: number;
  @Input() isDropdownItem = false;
  @Input() updateApplicationViewMap = false;
  @Input() clientId: number;
  @Input() clientName: string;

  sub = new Subscription();

  constructor (
    private modalFactory: ModalFactory,
    private collaborationService: CollaborationService
  ) {
    this.sub.add(
      this.collaborationService.changesTo$('collaboratorMap')
        .subscribe(() => {
          const map = this.collaborationService.collaboratorMap;
          this.numberOfApplicants = map[this.applicationId] ?
            map[this.applicationId].length :
            this.numberOfApplicants;
        })
    );
  }

  async openModal () {
    await this.modalFactory.open(CollaborationModalComponent, {
      applicationId: this.applicationId,
      sendNotificationsByDefault: this.sendNotificationsByDefault,
      updateApplicationViewMap: this.updateApplicationViewMap,
      isNomination: this.forNomination,
      clientId: this.clientId,
      clientName: this.clientName
    });
  }

  ngOnDestroy () {
    this.sub.unsubscribe();
  }
}
